module.exports = __webpack_public_path__ + "static/media/screen1.518227ed.png";